import React from 'react';

import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';
import { Plus, CheckCircle, XCircle, FileText, Download } from 'lucide-react';

export default function AdhesionsModals({ ctx }) {
  const { t: t, tarifs, membres, openCreateAdhesion, setOpenCreateAdhesion, openCreateTarif, setOpenCreateTarif, openDetailAdhesion, setOpenDetailAdhesion, openValidation, setOpenValidation, openGenererDoc, setOpenGenererDoc, selectedAdhesion, adhesionForm, setAdhesionForm, tarifForm, setTarifForm, validationData, setValidationData, handleCreateAdhesion, handleCreateTarif, handleValiderRejeter, handleGenererDocument } = ctx;
  return (
    <>
      <Dialog open={openCreateAdhesion} onOpenChange={setOpenCreateAdhesion}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Créer une nouvelle adhésion</DialogTitle>
            <DialogDescription>
              Créer manuellement une adhésion pour un membre
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div>
              <Label>Membre *</Label>
              <Select 
                value={adhesionForm.membre_id} 
                onValueChange={(value) => setAdhesionForm({...adhesionForm, membre_id: value})}
              >
                <SelectTrigger className="mt-2">
                  <SelectValue placeholder="Sélectionner un membre" />
                </SelectTrigger>
                <SelectContent>
                  {membres.map((membre) => (
                    <SelectItem key={membre.id} value={membre.id}>
                      {membre.prenom} {membre.nom} - {membre.email}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Type d'adhésion *</Label>
                <Select 
                  value={adhesionForm.type_adhesion} 
                  onValueChange={(value) => setAdhesionForm({...adhesionForm, type_adhesion: value})}
                >
                  <SelectTrigger className="mt-2">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="standard">Standard</SelectItem>
                    <SelectItem value="entreprise">Entreprise</SelectItem>
                    <SelectItem value="premium">Premium</SelectItem>
                    <SelectItem value="etudiant">Étudiant</SelectItem>
                    <SelectItem value="personnalise">Personnalisé</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div>
                <Label>Tarif (optionnel)</Label>
                <Select 
                  value={adhesionForm.tarif_id} 
                  onValueChange={(value) => {
                    const tarif = tarifs.find(t => t.id === value);
                    setAdhesionForm({
                      ...adhesionForm, 
                      tarif_id: value,
                      montant: tarif ? tarif.montant_annuel : adhesionForm.montant
                    });
                  }}
                >
                  <SelectTrigger className="mt-2">
                    <SelectValue placeholder="Aucun tarif" />
                  </SelectTrigger>
                  <SelectContent>
                    {tarifs.filter(t => t.actif).map((tarif) => (
                      <SelectItem key={tarif.id} value={tarif.id}>
                        {tarif.nom} - {tarif.montant_annuel} €
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Montant (€) *</Label>
                <Input
                  type="number"
                  min="0"
                  step="0.01"
                  value={adhesionForm.montant}
                  onChange={(e) => setAdhesionForm({...adhesionForm, montant: parseFloat(e.target.value)})}
                  className="mt-2"
                />
              </div>

              <div>
                <Label>Durée (mois) *</Label>
                <Input
                  type="number"
                  min="1"
                  value={adhesionForm.duree_mois}
                  onChange={(e) => setAdhesionForm({...adhesionForm, duree_mois: parseInt(e.target.value)})}
                  className="mt-2"
                />
              </div>
            </div>

            <div>
              <Label>Notes</Label>
              <Textarea
                value={adhesionForm.notes}
                onChange={(e) => setAdhesionForm({...adhesionForm, notes: e.target.value})}
                rows={3}
                className="mt-2"
                placeholder="Informations complémentaires..."
              />
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setOpenCreateAdhesion(false)}>
              Annuler
            </Button>
            <Button onClick={handleCreateAdhesion}>
              <Plus className="h-4 w-4 mr-2" />
              Créer l'adhésion
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Créer Tarif */}
      <Dialog open={openCreateTarif} onOpenChange={setOpenCreateTarif}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>Créer un nouveau tarif</DialogTitle>
            <DialogDescription>
              Définir un nouveau tarif d'adhésion
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div>
              <Label>Nom du tarif *</Label>
              <Input
                value={tarifForm.nom}
                onChange={(e) => setTarifForm({...tarifForm, nom: e.target.value})}
                placeholder="Ex: Adhésion Standard 2025"
                className="mt-2"
              />
            </div>

            <div>
              <Label>Type d'adhésion *</Label>
              <Select 
                value={tarifForm.type_adhesion} 
                onValueChange={(value) => setTarifForm({...tarifForm, type_adhesion: value})}
              >
                <SelectTrigger className="mt-2">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="standard">Standard</SelectItem>
                  <SelectItem value="entreprise">Entreprise</SelectItem>
                  <SelectItem value="premium">Premium</SelectItem>
                  <SelectItem value="etudiant">Étudiant</SelectItem>
                  <SelectItem value="personnalise">Personnalisé</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label>Description</Label>
              <Textarea
                value={tarifForm.description}
                onChange={(e) => setTarifForm({...tarifForm, description: e.target.value})}
                rows={3}
                className="mt-2"
                placeholder="Description du tarif..."
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Montant annuel (€) *</Label>
                <Input
                  type="number"
                  min="0"
                  step="0.01"
                  value={tarifForm.montant_annuel}
                  onChange={(e) => setTarifForm({...tarifForm, montant_annuel: parseFloat(e.target.value)})}
                  className="mt-2"
                />
              </div>

              <div>
                <Label>Montant mensuel (€)</Label>
                <Input
                  type="number"
                  min="0"
                  step="0.01"
                  value={tarifForm.montant_mensuel}
                  onChange={(e) => setTarifForm({...tarifForm, montant_mensuel: parseFloat(e.target.value)})}
                  className="mt-2"
                />
              </div>
            </div>

            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={tarifForm.actif}
                onChange={(e) => setTarifForm({...tarifForm, actif: e.target.checked})}
                className="h-4 w-4"
              />
              <Label>Tarif actif</Label>
            </div>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setOpenCreateTarif(false)}>
              Annuler
            </Button>
            <Button onClick={handleCreateTarif}>
              <Plus className="h-4 w-4 mr-2" />
              Créer le tarif
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Validation/Rejet */}
      <Dialog open={openValidation} onOpenChange={setOpenValidation}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {validationData.action === 'valider' ? 'Valider l\'adhésion' : 'Rejeter l\'adhésion'}
            </DialogTitle>
            <DialogDescription>
              {validationData.action === 'valider' 
                ? 'Confirmer la validation de cette demande d\'adhésion'
                : 'Indiquer la raison du rejet'
              }
            </DialogDescription>
          </DialogHeader>
          
          {selectedAdhesion && (
            <div className="py-4">
              <div className="bg-slate-50 p-4 rounded-lg mb-4">
                <p className="font-semibold">{selectedAdhesion.membre_nom}</p>
                <p className="text-sm text-slate-600">{selectedAdhesion.membre_email}</p>
                <p className="text-sm text-slate-600 mt-2">
                  Type: {selectedAdhesion.type_adhesion} • Montant: {selectedAdhesion.montant} €
                </p>
              </div>
              
              {validationData.action === 'rejeter' && (
                <div>
                  <Label>Raison du rejet *</Label>
                  <Textarea
                    value={validationData.raison}
                    onChange={(e) => setValidationData({...validationData, raison: e.target.value})}
                    rows={4}
                    className="mt-2"
                    placeholder="Expliquez la raison du rejet..."
                  />
                </div>
              )}
            </div>
          )}

          <DialogFooter>
            <Button variant="outline" onClick={() => setOpenValidation(false)}>
              Annuler
            </Button>
            <Button
              onClick={handleValiderRejeter}
              className={validationData.action === 'valider' ? 'bg-green-600 hover:bg-green-700' : ''}
              variant={validationData.action === 'rejeter' ? 'destructive' : 'default'}
            >
              {validationData.action === 'valider' ? (
                <>
                  <CheckCircle className="h-4 w-4 mr-2" />
                  Valider
                </>
              ) : (
                <>
                  <XCircle className="h-4 w-4 mr-2" />
                  Rejeter
                </>
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Détails Adhésion */}
      <Dialog open={openDetailAdhesion} onOpenChange={setOpenDetailAdhesion}>
        <DialogContent className="max-w-3xl">
          <DialogHeader>
            <DialogTitle>Détails de l'adhésion</DialogTitle>
          </DialogHeader>
          
          {selectedAdhesion && (
            <div className="space-y-4 py-4">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-xs text-slate-600">Numéro d'adhésion</Label>
                  <p className="font-mono font-semibold text-lg">{selectedAdhesion.numero_adhesion}</p>
                </div>
                <div>
                  <Label className="text-xs text-slate-600">Statut</Label>
                  <div className="mt-1">
                    <Badge className={
                      selectedAdhesion.statut === 'active' ? 'bg-green-600' :
                      selectedAdhesion.statut === 'en_attente' ? 'bg-orange-600' :
                      'bg-slate-700'
                    }>
                      {selectedAdhesion.statut}
                    </Badge>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-xs text-slate-600">Membre</Label>
                  <p className="font-semibold">{selectedAdhesion.membre_nom}</p>
                  <p className="text-sm text-slate-600">{selectedAdhesion.membre_email}</p>
                </div>
                <div>
                  <Label className="text-xs text-slate-600">Type d'adhésion</Label>
                  <p className="font-semibold capitalize">{selectedAdhesion.type_adhesion}</p>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div>
                  <Label className="text-xs text-slate-600">Montant</Label>
                  <p className="text-2xl font-bold text-blue-600">{selectedAdhesion.montant} €</p>
                </div>
                <div>
                  <Label className="text-xs text-slate-600">Durée</Label>
                  <p className="font-semibold">{selectedAdhesion.duree_mois} mois</p>
                </div>
                <div>
                  <Label className="text-xs text-slate-600">Créée le</Label>
                  <p className="text-sm">{new Date(selectedAdhesion.created_at).toLocaleDateString('fr-FR')}</p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-xs text-slate-600">Date de début</Label>
                  <p className="font-semibold">{new Date(selectedAdhesion.date_debut).toLocaleDateString('fr-FR')}</p>
                </div>
                <div>
                  <Label className="text-xs text-slate-600">Date de fin</Label>
                  <p className="font-semibold">{new Date(selectedAdhesion.date_fin).toLocaleDateString('fr-FR')}</p>
                </div>
              </div>

              {selectedAdhesion.notes && (
                <div>
                  <Label className="text-xs text-slate-600">Notes</Label>
                  <p className="text-sm text-slate-700 bg-slate-50 p-3 rounded mt-1">
                    {selectedAdhesion.notes}
                  </p>
                </div>
              )}

              {selectedAdhesion.documents_generes && selectedAdhesion.documents_generes.length > 0 && (
                <div>
                  <Label className="text-xs text-slate-600 mb-2 block">Documents générés</Label>
                  <div className="space-y-2">
                    {selectedAdhesion.documents_generes.map((doc, idx) => (
                      <div key={idx} className="flex items-center justify-between bg-slate-50 p-2 rounded">
                        <div className="flex items-center gap-2">
                          <FileText className="h-4 w-4 text-blue-600" />
                          <span className="text-sm">{doc.type}</span>
                        </div>
                        <span className="text-xs text-slate-500">
                          {new Date(doc.date_generation).toLocaleDateString('fr-FR')}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          <DialogFooter>
            <Button variant="outline" onClick={() => setOpenDetailAdhesion(false)}>
              Fermer
            </Button>
            <Button onClick={() => {
              setOpenDetailAdhesion(false);
              setOpenGenererDoc(true);
            }}>
              <Download className="h-4 w-4 mr-2" />
              Générer un document
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Générer Documents */}
      <Dialog open={openGenererDoc} onOpenChange={setOpenGenererDoc}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Générer un document</DialogTitle>
            <DialogDescription>
              Choisissez le type de document à générer
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-3 py-4">
            <Button 
              className="w-full justify-start" 
              variant="outline"
              onClick={() => handleGenererDocument('convention')}
            >
              <FileText className="h-4 w-4 mr-2" />
              Convention d'adhésion
            </Button>
            
            <Button 
              className="w-full justify-start" 
              variant="outline"
              onClick={() => handleGenererDocument('convention')}
            >
              <FileText className="h-4 w-4 mr-2" />
              Convention de partenariat
            </Button>
            
            <Button 
              className="w-full justify-start" 
              variant="outline"
              onClick={() => handleGenererDocument('confirmation')}
            >
              <Download className="h-4 w-4 mr-2" />
              Confirmation d'adhésion
            </Button>
          </div>

          <DialogFooter>
            <Button variant="outline" onClick={() => setOpenGenererDoc(false)}>
              Fermer
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
